const SELECTOR = '[data-component-switch]';
const SHOW_SELECTOR = '[data-show-match]';
const HIDE_SELECTOR = '[data-hide-match]';

function toggle($el, action) {
  switch (action) {
    case 'show':
      $el.removeClass('!hidden');
      break;
    case 'hide':
      $el.addClass('!hidden');
      break;
    default:
      $el.toggleClass('!hidden');
  }

  if ($el.hasClass('!hidden')) {
    $el.is(':input') ? $el.prop('disabled', true) : $el.find(':input').prop('disabled', true);
  } else {
    $el.is(':input') ? $el.prop('disabled', false) : $el.find(':input').prop('disabled', false);
  }
}

function applySwitch($el, $targets, trigger) {
  const checkMatch = condition => (trigger === 'click' ? $el.is(condition) : $el.val()?.match(condition));

  $targets.each((_, target) => {
    const $target = $(target);

    if (target.matches(SHOW_SELECTOR)) {
      checkMatch(target.dataset['showMatch']) ? toggle($target, 'show') : toggle($target, 'hide');
    } else if (target.matches(HIDE_SELECTOR)) {
      checkMatch(target.dataset['hideMatch']) ? toggle($target, 'hide') : toggle($target, 'show');
    } else if (trigger === 'click') toggle($el);
  });
}

function initSwitch(element) {
  const $el = $(element);
  const $targets = $(element.dataset['componentSwitch']);
  let trigger = element.dataset['watchEvent'];

  if ($el.is(':input')) {
    trigger = trigger || 'change';
    applySwitch($el, $targets, trigger);
  } else if ($el.has('input[type=radio]').length) {
    // For radio buttons we use a top container and to initialize it we pass the checked input
    trigger = trigger || 'change';
    applySwitch($el.find('input[type=radio]:checked'), $targets, trigger);
  } else {
    trigger = trigger || 'click';
    applySwitch($el, $targets, trigger);
  }

  $el.on(trigger, (e) => applySwitch($(e.target), $targets, trigger));
}

$(document).on('dom-update', e => $(e.target).find(SELECTOR).each((_, element) => initSwitch(element)));
